import { z } from "zod";
import type { infer as zInfer } from "zod/lib/types";
import { outcome } from "hooks/firestore/v2/models/outcome";
import { timestamp } from "hooks/firestore/v2/models/timestamp";
import { promotionCampaign } from "./promotionCampaign";

export const market = z.object({
  attributes: z.record(z.string(), z.any()).nullish(),
  allowedSelectionTypes: z.array(z.enum(["SingleOutcome", "SameEventMulti"])),
  category: z.string().nullish(),
  categoryId: z.string().nullish(),
  hasPromotionalMarkets: z.boolean().optional(),
  bettingType: z.enum(["Prematch", "Live"]),
  blockPromotionsBets: z.boolean().optional(),
  campaignOnly: z.boolean(),
  id: z.string(),
  independentPerEvent: z.boolean().optional(),
  marketType: z.string(),
  name: z.string(),
  outcomes: z.record(z.string(), outcome),
  promotional: z.boolean(),
  specifiers: z.record(z.string(), z.string()).optional(),
  status: z.enum([
    "ACTIVE",
    "SUSPENDED",
    "HANDED_OVER",
    "SETTLED",
    "CANCELLED",
    "DEACTIVATED",
    "UNAVAILABLE",
    "INVALID",
  ]),
  nextBetStop: z.union([timestamp, z.string()]).optional(),
  promotionCampaigns: z.array(promotionCampaign).nullish(),
});

export type Market = zInfer<typeof market>;
